import { Fragment } from "react";
import { Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import CartIcon from "../../components/cart-icon/cart-icon.component";
import CartDropdown from "../../components/cart-dropdown/cart-dropdown.component";

import { selectIsCartOpen } from '../../store/cart/cart.selector';
import { selectCurrentUser } from "../../store/user/user.selector";

import { ReactComponent as CrwnLogo } from "../../assets/crown.svg";

import {
  NavigationContainer,
  NavLinks,
  NavLink, 
  LogoContainer, 
  Title,
} from './nav-bar.styles.jsx'
import { signOutStart } from "../../store/user/user.action";

const Navigation = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector(selectCurrentUser);
  const isCartOpen = useSelector(selectIsCartOpen);
  const signOutUser = () => dispatch(signOutStart());

  return (
    <Fragment>
      <NavigationContainer>
          <LogoContainer className='logo-container' to='/'>
              <CrwnLogo className="logo" />
              <Title>J̶I̶G̶</Title>

          </LogoContainer>
          <NavLinks className="nav-links-container">
              <NavLink className="nav-links" to='/shop'>
                  Shop
              </NavLink>

           <NavLink className="nav-links" to='/sarah'>
               SM
           </NavLink>

                {currentUser ? (
                  <NavLink as='span' onClick={signOutUser}>
                    Sign Out
                  </NavLink>
                ) : (
                  <NavLink className="nav-links" to='/auth'>
                    Sign In
                  </NavLink>
                  )}
              <CartIcon />
          </NavLinks>
          {isCartOpen && <CartDropdown />}
      </NavigationContainer>
      <Outlet />
    </Fragment>
  );
};

export default Navigation;